module.exports = "https://s.pinimg.com/webapp/style/images/android-icon-1x-c02a3e12.png";